import { FC, useEffect, useState, useMemo } from 'react';
import { useStyles, BootstrapInput } from './styles';
import { useStore } from 'hooks/useRootStore';
import { useMutation, useQuery } from 'react-query';
import { useAppPreloader } from 'hooks/useAppPreloader';
import { GridColumns, DataGrid, GridRowParams, GridCellParams, GridSortDirection } from '@material-ui/data-grid';
import {
  Grid,
  Paper,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  Tooltip,
  Typography,
  DialogContent,
  Dialog,
  Menu,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import { DateRangePicker } from 'components/DateRangePicker';
import { Search } from 'components/Search';
import { AdditionalDataPopUp } from 'components/PopUps';
import { observer } from 'mobx-react-lite';
import { toJS } from 'mobx';
import { filterGroupsList } from './filterGropsList';
import { capitalizeFirstLetter, toFormatDateTime } from 'utils';
import { GridData } from './types';
import Calender from './../../../assets/icons/EndUser/Calender.svg';
import IPIcon from '../../../assets/icons/AdminIcons/IP.svg';
import { handleCompanyUrl } from 'utils/organizationUtils';
import Button from '@mui/material/Button';
import { useHistory } from 'react-router-dom';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';
import DownloadIcon from '@mui/icons-material/Download';
// import { getRowsPerPageOptions } from 'utils/pagination';
import EndUserSecurityInsights, { RiskData } from './EndUserSecurityInsights';
export const LogsTable: FC<GridData> = observer(({ getData, headtitle }) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const [selectedDescription, setSelectedDescription] = useState<string | React.ReactNode>('');
  // const [selectedDescription, setSelectedDescription] = useState<string | JSX.Element>('');
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  // const handleOpenDialog = (description: string) => {
  //   setSelectedDescription(description);
  //   setOpen(true);
  // };
  useEffect(() => {
    headtitle === 'admin' && (document.title = 'EasyIdentity: Reports: Admin Users');
    headtitle === 'enduser' && (document.title = 'EasyIdentity: Reports: End Users');
    headtitle === 'cloud' && (document.title = 'EasyIdentity: Reports: Cloud Directory');
  }, [headtitle]);
  const {
    // logsTableStore,
    logsTableStore: {
      // logsView,
      // setFilter,
      groupFilter,
      setGroupFilter,
      clickedId,
      setClickedId,
      getRenderValueForGroupSelect,
      dateRangeFilter,
      showAllDateRange,
      setDateRangeFilter,
      getLogsInfo,
      viewUser,
      getlogGroups,
      getlogDepartment,
      viewEndUser,
    },
    userStore: { user, getProfileInfo },
    notificationStore: { openNotification },
  } = useStore();
  const [openAdditionalDataPopUp, setOpenAdditionalDataPopUp] = useState<boolean>(false);
  const [loader, setLoader] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [riskData, setRiskData] = useState<RiskData | null>(null);

  const getLogsReq = useQuery(
    ['getLogs', page, pageSize, searchTerm],
    () => {
      // Type assertion to ensure getData accepts 3 parameters
      return (getData as (page: number, limit: number, search?: string) => any)(page + 1, pageSize, searchTerm);
    },
    {
      keepPreviousData: true,
      onSuccess: (response) => {
        if (response?.meta?.total) {
          setTotalRows(response.meta.total);
        } else if (response?.data?.total) {
          setTotalRows(response.data.total);
        } else {
          setTotalRows(0);
        }
        if (response?.risk) {
          setRiskData(response.risk);
        }
      },
      onError: (error) => {
        console.error('API error:', error);
        openNotification('error', `Can't get logs`);
      },
    }
  );
  const getLogsInfoReq = useMutation('getLogsInfoReq', getLogsInfo, {
    onError: ({ message }: Error) => openNotification('error', message),
  });
  const getClickedUser = useMutation(
    'viewUser',
    (ClientId: number) => (user?.permission !== 'EndUser' ? viewUser(ClientId) : viewEndUser(ClientId)),
    {
      onSuccess: (user) => {
        let url;
        if (user?.data?.message === 'End User Group and Department') {
          url = `${handleCompanyUrl('/admin/profile')}`;
          window.open(url, '_blank');
        }
        localStorage.setItem('ClickedUser', JSON.stringify(user.data.user));
        if (user?.data?.message === 'User found') {
          url = `${handleCompanyUrl('/user/view')}`;
          window.open(url, '_blank');
        } else {
          url = `${handleCompanyUrl('/admin/profile')}`;
          window.open(url, '_blank');
        }
        window.open(url, '_blank');
      },
      onError: (error: any) => {
        setLoader(false); // Reset loader on error
        openNotification('error', error.data?.message || error.message || 'User not found');
      },
    }
  );
  const getClickedAdmin = useMutation('viewProfile', () => getProfileInfo(), {
    onSuccess: () => {
      const url = `${handleCompanyUrl('/admin/profile')}`;
      window.open(url, '_blank');
    },
    onError: (error: any) => {
      setLoader(false); // Reset loader on error
      openNotification('error', 'profile not found');
    },
  });

  const getClickedGroup = useMutation('viewGroup', (id: string) => getlogGroups(id), {
    onSuccess: () => {
      const url = `${handleCompanyUrl('/group/users')}`;
      window.open(url, '_blank');
    },
    onError: (error: any) => {
      setLoader(false); // Reset loader on error
      openNotification('error', 'Group not found');
    },
  });
  const getClickedDepartment = useMutation('viewDepartment', (id: string) => getlogDepartment(id), {
    onSuccess: () => {
      const url = `${handleCompanyUrl('/department/users')}`;
      window.open(url, '_blank');
    },
    onError: (error: any) => {
      setLoader(false); // Reset loader on error
      openNotification('error', 'department not found');
    },
  });
  useAppPreloader(
    getLogsReq.isFetching ||
      getLogsInfoReq.isLoading ||
      getClickedGroup.isLoading ||
      getClickedUser.isLoading ||
      getClickedAdmin.isLoading ||
      loader
  );

  const handleCloseAdditionalDataPopUp = () => {
    setOpenAdditionalDataPopUp(false);
    setClickedId(0);
  };
  const rows = useMemo(() => {
    const responseData = getLogsReq.data;

    // Handle direct API response
    if (responseData?.data?.data) {
      const logsData = responseData.data.data;
      const processedRows = logsData.map((row: any) => {
        // Handle description with proper fallback
        let description = row.description;
        if (!description || description === 'undefined' || description.includes('undefined')) {
          if (row.log_name === 'user_sync') {
            description = 'User synced with app';
          } else if (row.log_name === 'user' && row.properties?.action) {
            description = `User ${row.properties.action}`;
          } else {
            description = 'Activity logged';
          }
        }

        if (typeof description === 'string') {
          description = description
            .replace(/undefined/g, '')
            .replace(/\s+/g, ' ')
            .trim();
        }

        return {
          ...row,
          id: row.id,
          ip: row.properties?.ip || row.properties?.ip_address || 'N/A',
          email: row.properties?.email || row.subject?.email || row.causer?.email || 'N/A',
          clientEmail: row.properties?.clientEmail || row.properties?.email || 'N/A',
          description: description,
          type: row.log_name,
          additionalData: JSON.stringify(row.properties || {}),
          createdAt: row.created_at,
          clientId: row.properties?.client_id,
          created_by: row.properties?.created_by || row.causer_id,
          causer_id: row.causer_id,
          subject_id: row.subject_id,
          city: row.properties?.city || '',
          country: row.properties?.country || '',
          zip_code: row.properties?.zip_code || '',
        };
      });

      return processedRows;
    }

    // Handle store response (normalized data) - fallback
    if (responseData?.logs) {
      const logsData = toJS(responseData.logs);
      return logsData;
    }

    return [];
  }, [getLogsReq.data]);

  const handleExportPDF = () => {
    const doc = new jsPDF();
    const downloadDateTime = new Date().toLocaleString();
    const logoBase64 =
      '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';
    doc.addImage(logoBase64, 'PNG', 5, 5, 30, 8);
    doc.text(`Time: ${downloadDateTime}`, 208, 10, { align: 'right' });
    doc.text(`Report : User Activity`, 70, 20);
    const tableColumn =
      headtitle === 'cloud' ? ['Date and Time', 'Description'] : ['Date and Time', 'IP Address', 'Description'];
    const tableRows =
      headtitle === 'cloud'
        ? rows.map((row: any) => [toFormatDateTime(row.createdAt ? row.createdAt.toString() : ''), row.description])
        : rows.map((row: any) => [
            toFormatDateTime(row.createdAt ? row.createdAt.toString() : ''),
            row.ip,
            row.description,
          ]);
    doc.autoTable({
      head: [tableColumn],
      body: tableRows,
      columnStyles:
        headtitle === 'cloud'
          ? {
              0: { cellWidth: 50 },
              1: { cellWidth: 120 },
            }
          : {
              0: { cellWidth: 50 },
              1: { cellWidth: 40 },
              2: { cellWidth: 90 },
            },
      headStyles: {
        fontSize: 10,
        minCellHeight: 10,
      },
      styles: {
        overflow: 'linebreak',
      },
      startY: 25,
    });
    doc.save('logs-report.pdf');
  };
  const handleExportCSV = () => {
    const tableHeaders =
      headtitle === 'cloud' ? ['Date and Time', 'Description'] : ['Date and Time', 'IP Address', 'Description'];
    const csvRows =
      headtitle === 'cloud'
        ? rows.map((row: any) => [toFormatDateTime(row.createdAt ? row.createdAt.toString() : ''), row.description])
        : rows.map((row: any) => [
            toFormatDateTime(row.createdAt ? row.createdAt.toString() : ''),
            row.ip,
            row.description,
          ]);

    let csvContent = '';
    csvContent += tableHeaders.join(',') + '\n';
    csvRows.forEach((row: any) => {
      csvContent += row.join(',') + '\n';
    });
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', 'logs-report.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleExportXLS = () => {
    const tableHeaders =
      headtitle === 'cloud' ? ['Date and Time', 'Description'] : ['Date and Time', 'IP Address', 'Description'];
    const xlsRows =
      headtitle === 'cloud'
        ? rows.map((row: any) => [toFormatDateTime(row.createdAt ? row.createdAt.toString() : ''), row.description])
        : rows.map((row: any) => [
            toFormatDateTime(row.createdAt ? row.createdAt.toString() : ''),
            row.ip,
            row.description,
          ]);
    const dataForXls = [tableHeaders, ...xlsRows];
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(dataForXls);
    XLSX.utils.book_append_sheet(wb, ws, 'Logs Report');
    XLSX.writeFile(wb, 'logs-report.xlsx');
  };
  const columns: GridColumns = [
    { field: 'id', headerName: 'ID', width: 300, hide: true },
    {
      field: 'createdAt',
      headerName: 'DATE AND TIME',
      flex: 1,
      renderHeader: () => (
        <Tooltip title='DATE AND TIME' placement='top' enterTouchDelay={0} leaveTouchDelay={1500} arrow>
          <span
            style={{
              fontSize: isMobile ? '10px' : isTablet ? '12px' : '14px',
              fontWeight: 'bold',
              cursor: 'pointer',
              display: 'block',
              textAlign: 'center',
              lineHeight: isMobile ? '1.2' : '1.4',
            }}
          >
            {isMobile ? 'DATE & TIME' : 'DATE AND TIME'}
          </span>
        </Tooltip>
      ),
      renderCell: (params: GridCellParams) => (
        <Tooltip title={toFormatDateTime(params.row.createdAt.toString())} placement='bottom'>
          <div
            style={{
              display: 'flex',
              gap: isMobile ? '4px' : '10px',
              alignItems: 'center',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              maxWidth: '100%',
            }}
          >
            <img
              src={Calender}
              alt=''
              style={{ width: isMobile ? '14px' : '16px', height: isMobile ? '14px' : '16px' }}
            />
            <span style={{ fontSize: isMobile ? '11px' : '13px' }}>
              {toFormatDateTime(params.row.createdAt.toString())}
            </span>
          </div>
        </Tooltip>
      ),
    },
    {
      field: 'description',
      headerName: 'DESCRIPTION',
      flex: 2.2,
      renderHeader: () => (
        <Tooltip title='DESCRIPTION' placement='top' enterTouchDelay={0} leaveTouchDelay={1500} arrow>
          <span
            style={{
              fontSize: isMobile ? '10px' : isTablet ? '12px' : '14px',
              fontWeight: 'bold',
              cursor: 'pointer',
              display: 'block',
              textAlign: 'center',
              lineHeight: isMobile ? '1.2' : '1.4',
            }}
          >
            DESCRIPTION
          </span>
        </Tooltip>
      ),
      renderCell: (params: any) => {
        const { value } = params;
        const truncatedDescriptionInitialize =
          value.length > (isMobile ? 50 : 100) ? value.substring(0, isMobile ? 50 : 100) + '...' : value;
        const userIndex = value.indexOf('with');
        const userIdIndex = value.indexOf('Created:');
        const userlogIndex = value.indexOf('Logged');
        const userNameIndex = value.indexOf('User:');
        const userWord = value.substring(userNameIndex + 6).split(' ')[0];
        const userGroupIndex = value.indexOf('Group:');
        const userDepartmentIndex = value.indexOf('Department:');
        const userGroupsDn = value.indexOf('dn:');
        const userPassword = value.indexOf('Reset');
        const userProfileIndex = value.indexOf('Profile');
        const userUpgradeIndex = value.indexOf('reached.');
        const userByIndex = value.indexOf('by');
        const userAcceptedIndex = value.indexOf('Accepted.');
        const testClientIndex = value.indexOf('Test clientdddddd');
        const userIdPatternIndex = value.indexOf('(ID:');
        const emailPattern = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/;
        const emailMatch = value.match(emailPattern);
        const emailIndex = emailMatch ? value.indexOf(emailMatch[0]) : -1;
        const userForIndex = value.indexOf(' for ');
        const userForPattern = userForIndex !== -1 ? value.substring(userForIndex + 5).split(' by ')[0] : null;
        const departmentCreatedIndex = value.indexOf(' department created');
        const groupCreatedIndex = value.indexOf(' group created');
        const departmentDeletedIndex = value.indexOf(' department deleted');
        const groupDeletedIndex = value.indexOf(' group deleted');
        const departmentUpdatedIndex = value.indexOf(' department updated');
        const groupUpdatedIndex = value.indexOf(' group updated');
        const departmentName =
          departmentCreatedIndex !== -1
            ? value.substring(0, departmentCreatedIndex)
            : departmentDeletedIndex !== -1
            ? value.substring(0, departmentDeletedIndex)
            : departmentUpdatedIndex !== -1
            ? value.substring(0, departmentUpdatedIndex)
            : null;
        const groupName =
          groupCreatedIndex !== -1
            ? value.substring(0, groupCreatedIndex)
            : groupDeletedIndex !== -1
            ? value.substring(0, groupDeletedIndex)
            : groupUpdatedIndex !== -1
            ? value.substring(0, groupUpdatedIndex)
            : null;
        // Get actual client name from message after 'by '
        const byClientPattern = value.includes(' by ') ? value.split(' by ')[1]?.trim() : null;
        const descriptionBeforeUserName = truncatedDescriptionInitialize.substring(
          0,
          userNameIndex !== -1 ? userNameIndex : value.length
        );
        const descriptionBeforeGroup = truncatedDescriptionInitialize.substring(
          0,
          userGroupIndex !== -1 ? userGroupIndex : value.length
        );
        const descriptionBeforeDepartment = truncatedDescriptionInitialize.substring(
          0,
          userDepartmentIndex !== -1 ? userDepartmentIndex : value.length
        );
        const descriptionBeforeProfile = truncatedDescriptionInitialize.substring(
          0,
          userProfileIndex !== -1 ? userProfileIndex : value.length
        );
        const descriptionBeforeUpgrade = truncatedDescriptionInitialize.substring(
          0,
          userUpgradeIndex !== -1 ? userUpgradeIndex : value.length
        );
        const descriptionBeforeAccepted = truncatedDescriptionInitialize.substring(
          0,
          userAcceptedIndex !== -1 ? userAcceptedIndex : value.length
        );
        const descriptionBeforeUserId = truncatedDescriptionInitialize.substring(
          0,
          userIdIndex !== -1 ? userIdIndex : value.length
        );
        const descriptionBeforeUser = truncatedDescriptionInitialize.substring(
          0,
          userIndex !== -1 ? userIndex : value.length
        );
        const descriptionAfterUserName =
          userNameIndex !== -1 ? truncatedDescriptionInitialize.substring(userNameIndex + 5) : '';
        const descriptionAfterBy = userByIndex !== -1 ? truncatedDescriptionInitialize.substring(userByIndex + 3) : '';
        const descriptionAfterGroup =
          userGroupIndex !== -1 ? truncatedDescriptionInitialize.substring(userGroupIndex + 5) : '';
        const descriptionAfterDepartment =
          userDepartmentIndex !== -1 ? truncatedDescriptionInitialize.substring(userDepartmentIndex + 10) : '';
        const descriptionAfterGroups =
          userGroupsDn !== -1 ? truncatedDescriptionInitialize.substring(userGroupsDn + 4) : '';
        const text = descriptionAfterGroups;
        const result = text.split(' by ')[0];
        const descriptionAfterProfile =
          userProfileIndex !== -1 ? truncatedDescriptionInitialize.substring(userProfileIndex + 7) : '';
        const descriptionAfterUpgrade = userUpgradeIndex !== -1 ? ' Upgrade' : '';
        const descriptionAfterAccepted =
          userAcceptedIndex !== -1 ? truncatedDescriptionInitialize.substring(userAcceptedIndex) : '';
        const descriptionAfterUserlog =
          userlogIndex !== -1 ? truncatedDescriptionInitialize.substring(userlogIndex) : '';
        const descriptionAfterUserId = userIdIndex !== -1 ? truncatedDescriptionInitialize.substring(userIdIndex) : '';
        const descriptionAfterUser = userIndex !== -1 ? truncatedDescriptionInitialize.substring(userIndex) : '';
        const descriptionAfterPassword =
          userPassword !== -1 ? truncatedDescriptionInitialize.substring(userPassword) : '';
        const truncatedDescription =
          descriptionBeforeUserId.length > 100
            ? descriptionBeforeUserId.substring(0, 100) + '...'
            : descriptionBeforeUserId;
        const truncatedUserDescription =
          descriptionBeforeUser.length > 100 ? descriptionBeforeUser.substring(0, 100) + '...' : descriptionBeforeUser;
        const truncatedDescriptions =
          descriptionBeforeUserName.length > 100
            ? descriptionBeforeUserName.substring(0, 100) + '...'
            : descriptionBeforeUserName;
        const truncatedDescriptionGroup =
          descriptionBeforeGroup.length > 100
            ? descriptionBeforeGroup.substring(0, 100) + '...'
            : descriptionBeforeGroup;
        const truncatedDescriptionDepartment =
          descriptionBeforeDepartment.length > 100
            ? descriptionBeforeDepartment.substring(0, 100) + '...'
            : descriptionBeforeDepartment;
        const truncatedDescriptionProfile =
          descriptionBeforeProfile.length > 100
            ? descriptionBeforeProfile.substring(0, 100) + '...'
            : descriptionBeforeProfile;
        const truncatedDescriptionUpgrade =
          descriptionBeforeUpgrade.length > 100
            ? descriptionBeforeUpgrade.substring(0, 100) + '...'
            : descriptionBeforeUpgrade;
        const handleClick = (event: any) => {
          const id = params.row.subject_id;
          event.stopPropagation();
          getClickedUser.mutate(id);
        };
        const handleClicked = (event: any) => {
          const id = params.row.causer_id;
          event.stopPropagation();
          if (id === 1) {
            const url = `${handleCompanyUrl('/admin/profile')}`;
            window.open(url, '_blank');
          } else {
            getClickedUser.mutate(id);
          }
        };
        const handleClicks = (event: any) => {
          const id = params.row.clientId;
          event.stopPropagation();
          getClickedAdmin.mutate(id);
        };
        const handleGroup = () => {
          getClickedGroup.mutate(result);
        };
        const handleDepartment = () => {
          getClickedDepartment.mutate(result);
        };
        // const handleTestClient = (event: any) => {
        //   event.stopPropagation();
        //   const causerId = params.row.causer_id;
        //   if (causerId) {
        //     const url = `${handleCompanyUrl('/admin/profile')}`;
        //     window.open(url, '_blank');
        //   }
        // };
        const handleClientClick = (event: any) => {
          event.stopPropagation();
          let causerId = params.row.causer_id || params.row.created_by;

          // If still null, try to get from original row data
          if (!causerId && params.row.causer) {
            causerId = params.row.causer.id;
          }

          // If still null, try properties
          if (!causerId && params.row.properties) {
            causerId = params.row.properties.causer_id;
          }

          if (causerId) {
            const url = `${handleCompanyUrl('/admin/profile')}`;
            window.open(url, '_blank');
          } else {
            const url = `${handleCompanyUrl('/admin/profile')}`;
            window.open(url, '_blank');
          }
        };
        const handleUserId = (event: any) => {
          event.stopPropagation();
          const subjectId = params.row.subject_id;
          if (subjectId) {
            getClickedUser.mutate(subjectId);
          }
        };
        const handleEmailClick = (event: any) => {
          event.stopPropagation();
          const subjectId = params.row.subject_id;
          if (subjectId) {
            getClickedUser.mutate(subjectId);
          }
        };
        const handleUserForClick = (event: any) => {
          event.stopPropagation();
          const subjectId = params.row.subject_id;
          if (subjectId) {
            getClickedUser.mutate(subjectId);
          }
        };
        const handleDepartmentCreatedClick = (event: any) => {
          event.stopPropagation();
          const subjectId = params.row.subject_id;
          if (subjectId) {
            getClickedDepartment.mutate(subjectId);
          }
        };
        const handleGroupCreatedClick = (event: any) => {
          event.stopPropagation();
          // Handle group name click - for now just log, need proper DN
          const subjectId = params.row.subject_id;
          if (subjectId) {
            getClickedGroup.mutate(subjectId);
          }
          // TODO: Need to get proper DN for group API call
          // getClickedGroup.mutate(groupDn);
        };
        const handleDepartmentDeletedClick = (event: any) => {
          event.stopPropagation();
          const subjectId = params.row.subject_id;
          if (subjectId) {
            getClickedDepartment.mutate(subjectId);
          }
        };
        const handleDepartmentUpdatedClick = (event: any) => {
          event.stopPropagation();
          const subjectId = params.row.subject_id;
          if (subjectId) {
            getClickedDepartment.mutate(subjectId);
          }
        };
        const handleGroupDeletedClick = (event: any) => {
          event.stopPropagation();
          const subjectId = params.row.subject_id;
          if (subjectId) {
            getClickedGroup.mutate(subjectId);
          }
        };
        const handleGroupUpdatedClick = (event: any) => {
          event.stopPropagation();
          const subjectId = params.row.subject_id;
          if (subjectId) {
            getClickedGroup.mutate(subjectId);
          }
        };

        // Update the parseLogMessage function to include hasClickableElements property
        const parseLogMessage = (message: string) => {
          const groupCreatedMatch = message.match(/Group created \(Name: ([^)]+)\)/);
          const groupDeletedMatch = message.match(/Group deleted: ([^\s]+)/);
          const groupUpdatedMatch = message.match(/Group updated[^:]*: ([^\s]+)/);
          const deptCreatedMatch = message.match(/Department created \(Name: ([^)]+)\)/);
          const deptDeletedMatch = message.match(/Department deleted: ([^\s]+)/);
          const deptUpdatedMatch = message.match(/Department updated[^:]*: ([^\s]+)/);
          const clientMatch = message.match(/by ([A-Za-z0-9\s]+?)(?:\s*\(|$)/);
          const endUserMatch = message.match(/End-User ([^\s]+@[^\s]+)/);
          const emailPattern = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/;
          const emailInMessage = message.match(emailPattern);
          const userIdMatch = message.match(/\(ID:\s*([^)]+)\)/);

          // User identifier pattern - match google_xxx, zoom_xxx, or similar user identifiers
          const userIdentifierMatches = message.match(
            /((?:google_|zoom_|microsoft_|facebook_|github_|linkedin_)[a-zA-Z0-9_]+)/g
          );

          // User pattern - match User: something or "for username by" pattern
          const userNameMatch = message.match(/User:\s*([^\s,]+)/) || message.match(/\sfor\s+([^\s]+)\s+by\s/);

          // Special pattern for "for username by" - get the username between "for" and "by"
          const forUserByMatch = message.match(/\sfor\s+([^\s]+)\s+by\s/);

          // Group/Department in old format - only match if message has explicit 'Group:' or 'Department:' prefix
          const oldGroupMatch = message.match(/^Group\s*([^,\s]+)/);
          const oldDeptMatch = message.match(/^Department\s*([^,\s]+)/);

          const hasClickableElements = !!(
            clientMatch ||
            endUserMatch ||
            emailInMessage ||
            userIdMatch ||
            userIdentifierMatches ||
            userNameMatch ||
            groupCreatedMatch ||
            groupDeletedMatch ||
            groupUpdatedMatch ||
            deptCreatedMatch ||
            deptDeletedMatch ||
            deptUpdatedMatch ||
            oldGroupMatch ||
            oldDeptMatch
          );

          return {
            groupName: groupCreatedMatch?.[1] || groupDeletedMatch?.[1] || groupUpdatedMatch?.[1] || oldGroupMatch?.[1],
            deptName: deptCreatedMatch?.[1] || deptDeletedMatch?.[1] || deptUpdatedMatch?.[1] || oldDeptMatch?.[1],
            clientName: clientMatch?.[1]?.trim(),
            endUserEmail: endUserMatch?.[1],
            emailInMessage: emailInMessage?.[1],
            userId: userIdMatch?.[1],
            userIdentifiers: userIdentifierMatches || [],
            userName: forUserByMatch?.[1] || userNameMatch?.[1], // Prioritize 'for username by' pattern
            isAttributeMapping: false,
            hasLinks: hasClickableElements,
            hasClickableElements,
          };
        };

        const parsed = parseLogMessage(value);

        // Define renderMessageWithLinks function that can be used anywhere
        const renderMessageWithLinks = (message: string) => {
          const parts = [];
          let lastIndex = 0;
          const processedIndices = new Set();

          // Helper function to add clickable element
          const addClickableElement = (
            text: string,
            startIndex: number,
            endIndex: number,
            onClick: (e: any) => void,
            key: string
          ) => {
            if (processedIndices.has(startIndex)) return false;

            // Add text before the clickable element
            if (startIndex > lastIndex) {
              parts.push(message.substring(lastIndex, startIndex));
            }

            // Add clickable element
            parts.push(
              <span key={key} onClick={onClick} className={classes.link}>
                {text}
              </span>
            );

            // Mark this range as processed
            for (let i = startIndex; i < endIndex; i++) {
              processedIndices.add(i);
            }

            lastIndex = endIndex;
            return true;
          };

          // Process all clickable elements in order of appearance
          const clickableElements = [];

          // Group names
          if (parsed.groupName) {
            const index = message.indexOf(parsed.groupName);
            if (index !== -1) {
              clickableElements.push({
                index,
                endIndex: index + parsed.groupName.length,
                text: parsed.groupName,
                onClick: (e: any) => {
                  e.stopPropagation();
                  const subjectId = params.row.subject_id;
                  if (subjectId) getClickedGroup.mutate(subjectId);
                },
                key: 'group-name',
              });
            }
          }

          // Department names
          if (parsed.deptName) {
            const index = message.indexOf(parsed.deptName);
            if (index !== -1) {
              clickableElements.push({
                index,
                endIndex: index + parsed.deptName.length,
                text: parsed.deptName,
                onClick: (e: any) => {
                  e.stopPropagation();
                  const subjectId = params.row.subject_id;
                  if (subjectId) getClickedDepartment.mutate(subjectId);
                },
                key: 'dept-name',
              });
            }
          }

          // User IDs
          if (parsed.userId) {
            const fullMatch = `(ID: ${parsed.userId})`;
            const index = message.indexOf(fullMatch);
            if (index !== -1) {
              clickableElements.push({
                index,
                endIndex: index + fullMatch.length,
                text: fullMatch,
                onClick: (e: any) => {
                  e.stopPropagation();
                  const subjectId = params.row.subject_id;
                  if (subjectId) getClickedUser.mutate(subjectId);
                },
                key: 'user-id',
              });
            }
          }

          // User names
          if (parsed.userName) {
            let index = -1;

            // If it's a 'for username by' pattern, find the occurrence after 'for'
            if (message.includes(' for ' + parsed.userName + ' by ')) {
              const forPattern = ' for ' + parsed.userName + ' by ';
              const forIndex = message.indexOf(forPattern);
              if (forIndex !== -1) {
                index = forIndex + 5; // Position after ' for '
              }
            } else {
              // Regular User: pattern
              index = message.indexOf(parsed.userName);
            }

            if (index !== -1) {
              clickableElements.push({
                index,
                endIndex: index + parsed.userName.length,
                text: parsed.userName,
                onClick: (e: any) => {
                  e.stopPropagation();

                  const subjectId = params.row.subject_id;
                  if (subjectId) {
                    getClickedUser.mutate(subjectId);
                  } else {
                    console.log('No subject_id found for username click');
                  }
                },
                key: 'user-name',
              });
            }
          }

          // User identifiers (google_xxx, zoom_xxx, etc.)
          // if (parsed.userIdentifiers && parsed.userIdentifiers.length > 0) {
          //   parsed.userIdentifiers.forEach((identifier, idx) => {
          //     const index = message.indexOf(identifier);
          //     if (index !== -1) {
          //       clickableElements.push({
          //         index,
          //         endIndex: index + identifier.length,
          //         text: identifier,
          //         onClick: (e: any) => {
          //           e.stopPropagation();
          //           const subjectId = params.row.subject_id;
          //           if (subjectId) getClickedUser.mutate(subjectId);
          //         },
          //         key: `user-identifier-${idx}`
          //       });
          //     }
          //   });
          // }

          if (parsed.userIdentifiers && parsed.userIdentifiers.length > 0) {
            (parsed.userIdentifiers as string[]).forEach((identifier, idx) => {
              const index = message.indexOf(identifier);

              if (index !== -1) {
                clickableElements.push({
                  index,
                  endIndex: index + identifier.length,
                  text: identifier,
                  onClick: (e: any) => {
                    e.stopPropagation();
                    const subjectId = params.row.subject_id;
                    if (subjectId) {
                      getClickedUser.mutate(subjectId);
                    }
                  },
                  key: `user-identifier-${idx}`,
                });
              }
            });
          }

          // Emails
          if (parsed.emailInMessage) {
            const index = message.indexOf(parsed.emailInMessage);
            if (index !== -1) {
              clickableElements.push({
                index,
                endIndex: index + parsed.emailInMessage.length,
                text: parsed.emailInMessage,
                onClick: (e: any) => {
                  e.stopPropagation();
                  const subjectId = params.row.subject_id;
                  if (subjectId) {
                    getClickedUser.mutate(subjectId);
                  } else {
                    console.log('No subject_id found for email click');
                  }
                },
                key: 'email',
              });
            }
          }

          // Client names (should be processed last to avoid conflicts)
          if (parsed.clientName) {
            const index = message.indexOf(parsed.clientName);
            if (index !== -1) {
              clickableElements.push({
                index,
                endIndex: index + parsed.clientName.length,
                text: parsed.clientName,
                onClick: handleClientClick,
                key: 'client-name',
              });
            }
          }

          // Sort by index and process
          clickableElements.sort((a, b) => a.index - b.index);

          clickableElements.forEach((element) => {
            addClickableElement(element.text, element.index, element.endIndex, element.onClick, element.key);
          });

          // Add remaining text
          if (lastIndex < message.length) {
            parts.push(message.substring(lastIndex));
          }

          return parts;
        };

        // If we have any links in the message, render with clickable elements
        if (parsed.hasClickableElements) {
          const truncatedMessage =
            value.length > (isMobile ? 50 : 100) ? value.substring(0, isMobile ? 50 : 100) + '...' : value;

          return (
            <div style={{ display: 'flex', width: '100%' }}>
              <div style={{ display: 'flex', flexDirection: 'row', overflow: 'hidden' }}>
                <Typography noWrap style={{ fontSize: isMobile ? '11px' : '14px' }}>
                  {renderMessageWithLinks(truncatedMessage)}
                </Typography>
              </div>
              {value.length > (isMobile ? 50 : 100) && (
                <Button
                  style={{
                    color: 'blue',
                    display: 'flex',
                    alignItems: 'flex-end',
                    justifyContent: 'flex-end',
                    fontSize: isMobile ? '10px' : '12px',
                    minWidth: isMobile ? '60px' : 'auto',
                    padding: isMobile ? '2px 4px' : '6px 8px',
                  }}
                  onClick={() => {
                    const dialogContent = (
                      <div style={{ fontSize: '14px', lineHeight: '1.5' }}>{renderMessageWithLinks(value)}</div>
                    );
                    setSelectedDescription(dialogContent);
                    setOpen(true);
                  }}
                >
                  {isMobile ? 'More' : 'Read more...'}
                </Button>
              )}
            </div>
          );
        }

        // Continue with existing complex logic for other patterns
        let processedDescription = descriptionAfterUserName;
        if (processedDescription.includes('with')) {
          processedDescription = processedDescription.substring(processedDescription.indexOf('with'));
        }
        const User = descriptionAfterUserId.split(':');
        const Password = descriptionAfterPassword.split(':');
        const afterPassword = descriptionAfterPassword.split(':')[1]?.trim();
        const firstWordafterPassword = afterPassword?.split(' ')[0];
        const remainingAfterFirstWord = afterPassword?.substring(firstWordafterPassword.length).trim();
        return (
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <div style={{ display: 'flex', flexDirection: 'row', overflow: 'hidden' }}>
              {userIdIndex !== -1 && userNameIndex === -1 && (
                <>
                  <Typography noWrap style={{ fontSize: isMobile ? '11px' : '14px' }}>
                    {truncatedDescription}
                  </Typography>
                  <Typography noWrap className={classes.text} style={{ fontSize: isMobile ? '11px' : '14px' }}>
                    {User[0]?.trim()} :{User[1]?.trim()}
                    <span onClick={handleClick} className={classes.link}>
                      {' ' + User[2]?.trim().split(',')[0]}
                    </span>
                    {descriptionAfterUserId.includes('by')
                      ? `${descriptionAfterUserId.split(',').slice(1).join(',').split('by')[0].trim()} by `
                      : descriptionAfterUserId.split(',').slice(1).join(',')}
                    <span onClick={handleClicked} className={classes.link}>
                      {descriptionAfterBy}
                    </span>
                  </Typography>
                </>
              )}
              {userlogIndex !== -1 && (
                <>
                  <Typography noWrap style={{ fontSize: isMobile ? '11px' : '14px' }}>
                    {descriptionAfterUserlog.split(':')[0]}:
                    {' ' + descriptionAfterUserlog.split(':')[1]?.trim().split(' ')[0]}:
                    <span onClick={handleClick} className={classes.link}>
                      {' ' + descriptionAfterUserlog.split(':')[2]?.trim().split(' ')[0]}
                    </span>
                    {descriptionAfterUserlog.split(',')[1]}
                  </Typography>
                </>
              )}
              {userIndex !== -1 &&
                userNameIndex === -1 &&
                !value.startsWith('User synced') &&
                !value.startsWith('Your account was synced with ') &&
                !value.startsWith('You ') && (
                  <>
                    <Typography noWrap style={{ fontSize: isMobile ? '11px' : '14px' }}>
                      {truncatedUserDescription}
                    </Typography>
                    <Typography noWrap className={classes.text} style={{ fontSize: isMobile ? '11px' : '14px' }}>
                      {descriptionAfterUser.split(':')[0].trim()}:
                      <span onClick={handleClick} className={classes.link}>
                        {' ' + descriptionAfterUser.split(':')[1]?.trim().split(' ')[0]}
                      </span>
                      {descriptionAfterUser.includes('by')
                        ? `${descriptionAfterUser.split(',').slice(1).join(',').split('by')[0].trim()} by `
                        : descriptionAfterUser.split(',').slice(1).join(',')}
                      <span onClick={handleClicked} className={classes.link}>
                        {descriptionAfterBy}
                      </span>
                    </Typography>
                  </>
                )}
              {userAcceptedIndex !== -1 && (
                <>
                  <Typography noWrap style={{ fontSize: isMobile ? '11px' : '14px' }}>
                    {descriptionBeforeAccepted}
                  </Typography>
                  <Typography noWrap className={classes.text} style={{ fontSize: isMobile ? '11px' : '14px' }}>
                    {descriptionAfterAccepted.split(':')[0].trim()}:
                    <span onClick={handleClick} className={classes.link}>
                      {' ' + descriptionAfterAccepted.split(':')[1]?.trim().split(',')[0]}
                    </span>
                    {descriptionAfterAccepted.includes('by')
                      ? `${descriptionAfterAccepted.split(',').slice(1).join(',').split('by')[0].trim()} by `
                      : descriptionAfterAccepted.split(',').slice(1).join(',')}
                    <span onClick={handleClicked} className={classes.link}>
                      {descriptionAfterBy}
                    </span>
                  </Typography>
                </>
              )}
              {userPassword !== -1 && (
                <>
                  <Typography noWrap style={{ fontSize: isMobile ? '11px' : '14px' }}>
                    {Password[0]?.trim()}
                  </Typography>
                  <Typography noWrap className={classes.text} style={{ fontSize: isMobile ? '11px' : '14px' }}>
                    <span onClick={handleClick} className={classes.link}>
                      {firstWordafterPassword}
                    </span>
                    {remainingAfterFirstWord}:{' '}
                    <span onClick={handleClick} className={classes.link}>
                      {Password[2]?.trim()}
                    </span>
                  </Typography>
                </>
              )}
              {userIdIndex === -1 && userNameIndex !== -1 && (
                <>
                  <Typography noWrap style={{ fontSize: isMobile ? '11px' : '14px' }}>
                    {truncatedDescriptions}
                  </Typography>
                  <Typography noWrap className={classes.text} style={{ fontSize: isMobile ? '11px' : '14px' }}>
                    User:
                    <span onClick={handleClick} className={classes.link}>
                      {userWord}
                    </span>
                    {descriptionAfterUserName && descriptionAfterUserName.includes('with') ? (
                      <>
                        {processedDescription.split('by')[0].trim()}
                        {' by '}
                        <span onClick={handleClicked} className={classes.link}>
                          {descriptionAfterBy}
                        </span>
                      </>
                    ) : (
                      <>
                        {descriptionAfterUserName}
                        <span onClick={handleClicked} className={classes.link}>
                          {descriptionAfterBy}
                        </span>
                      </>
                    )}
                  </Typography>
                </>
              )}
              {userGroupIndex !== -1 && (
                <>
                  <Typography noWrap style={{ fontSize: isMobile ? '11px' : '14px' }}>
                    {truncatedDescriptionGroup}
                  </Typography>
                  <Typography noWrap className={classes.text} style={{ fontSize: isMobile ? '11px' : '14px' }}>
                    Group
                    {descriptionAfterGroup.includes(',') ? (
                      <span onClick={handleGroup} className={classes.link}>
                        {descriptionAfterGroup.split(',')[0]}
                      </span>
                    ) : (
                      <span onClick={handleGroup} className={classes.link}>
                        {descriptionAfterGroup.split(' by ')[0]}
                      </span>
                    )}
                    {descriptionAfterGroup.includes(' by ')
                      ? `${descriptionAfterGroup.split(',').slice(1).join(',').split(' by ')[0]} by `
                      : `${descriptionAfterGroup.split(',').slice(1).join(',')}  by`}
                    <span onClick={handleClicked} className={classes.link}>
                      {descriptionAfterBy}
                    </span>
                  </Typography>
                </>
              )}
              {userDepartmentIndex !== -1 && (
                <>
                  <Typography noWrap style={{ fontSize: isMobile ? '11px' : '14px' }}>
                    {truncatedDescriptionDepartment}
                  </Typography>
                  <Typography noWrap className={classes.text} style={{ fontSize: isMobile ? '11px' : '14px' }}>
                    Department
                    {descriptionAfterDepartment.includes(',') ? (
                      <span onClick={handleDepartment} className={classes.link}>
                        {descriptionAfterDepartment.split(',')[0]}
                      </span>
                    ) : (
                      <span onClick={handleDepartment} className={classes.link}>
                        {descriptionAfterDepartment.split(' by ')[0]}
                      </span>
                    )}
                    {descriptionAfterDepartment.includes(' by ')
                      ? `${descriptionAfterDepartment.split(',').slice(1).join(',').split(' by ')[0]} by `
                      : `${descriptionAfterDepartment.split(',').slice(1).join(',')}  by`}
                    <span onClick={handleClicked} className={classes.link}>
                      {descriptionAfterBy}
                    </span>
                  </Typography>
                </>
              )}
              {userProfileIndex !== -1 && (
                <>
                  <Typography noWrap style={{ fontSize: isMobile ? '11px' : '14px' }}>
                    {truncatedDescriptionProfile}
                  </Typography>
                  <Typography noWrap className={classes.text} style={{ fontSize: isMobile ? '11px' : '14px' }}>
                    Profile
                    <span onClick={handleClicks} className={classes.link}>
                      {descriptionAfterProfile.substring(0, 7)}
                    </span>
                    {descriptionAfterProfile.slice(7)}
                  </Typography>
                </>
              )}
              {userUpgradeIndex !== -1 && (
                <>
                  <Typography noWrap style={{ fontSize: isMobile ? '11px' : '14px' }}>
                    {truncatedDescriptionUpgrade}
                  </Typography>
                  <Typography noWrap className={classes.text} style={{ fontSize: isMobile ? '11px' : '14px' }}>
                    reached
                    <span onClick={() => history.push(handleCompanyUrl('/upgrade-license'))} className={classes.link}>
                      {descriptionAfterUpgrade.substring(0, 15)}
                    </span>
                    {descriptionAfterProfile.slice(10)}
                  </Typography>
                </>
              )}
              {/* {userNameIndex === -1 &&
                userIdIndex === -1 &&
                userGroupIndex === -1 &&
                userProfileIndex === -1 &&
                userUpgradeIndex === -1 &&
                userByIndex === -1 &&
                userIndex === -1 &&
                userPassword === -1 &&
                userDepartmentIndex === -1 &&
                userAcceptedIndex === -1 &&
                userlogIndex === -1 && (
                  <>
                    <Typography noWrap>{truncatedDescription}</Typography>
                  </>
                )} */}
              {departmentCreatedIndex !== -1 && (
                <>
                  <Typography noWrap style={{ fontSize: isMobile ? '11px' : '14px' }}>
                    <span onClick={handleDepartmentCreatedClick} className={classes.link}>
                      {departmentName}
                    </span>
                    {' department created'}
                    {value.includes(' by ') && byClientPattern && (
                      <>
                        {' by '}
                        <span onClick={handleClientClick} className={classes.link}>
                          {byClientPattern}
                        </span>
                      </>
                    )}
                  </Typography>
                </>
              )}
              {departmentDeletedIndex !== -1 && departmentCreatedIndex === -1 && (
                <>
                  <Typography noWrap style={{ fontSize: isMobile ? '11px' : '14px' }}>
                    <span onClick={handleDepartmentDeletedClick} className={classes.link}>
                      {departmentName}
                    </span>
                    {' department deleted'}
                    {value.substring(departmentDeletedIndex + ' department deleted'.length).includes(' by ') &&
                      byClientPattern && (
                        <>
                          {' by '}
                          <span onClick={handleClientClick} className={classes.link}>
                            {byClientPattern}
                          </span>
                        </>
                      )}
                    {!value.substring(departmentDeletedIndex + ' department deleted'.length).includes(' by ') &&
                      value.substring(departmentDeletedIndex + ' department deleted'.length)}
                  </Typography>
                </>
              )}
              {groupCreatedIndex !== -1 && departmentCreatedIndex === -1 && departmentDeletedIndex === -1 && (
                <>
                  <Typography noWrap style={{ fontSize: isMobile ? '11px' : '14px' }}>
                    <span onClick={handleGroupCreatedClick} className={classes.link}>
                      {groupName}
                    </span>
                    {' group created'}
                    {value.substring(groupCreatedIndex + ' group created'.length).includes(' by ') &&
                      byClientPattern && (
                        <>
                          {' by '}
                          <span onClick={handleClientClick} className={classes.link}>
                            {byClientPattern}
                          </span>
                        </>
                      )}
                    {!value.substring(groupCreatedIndex + ' group created'.length).includes(' by ') &&
                      value.substring(groupCreatedIndex + ' group created'.length)}
                  </Typography>
                </>
              )}
              {departmentUpdatedIndex !== -1 && departmentCreatedIndex === -1 && departmentDeletedIndex === -1 && (
                <>
                  <Typography noWrap style={{ fontSize: isMobile ? '11px' : '14px' }}>
                    <span onClick={handleDepartmentUpdatedClick} className={classes.link}>
                      {departmentName}
                    </span>
                    {' department updated'}
                    {value.includes(' by ') && byClientPattern && (
                      <>
                        {' by '}
                        <span onClick={handleClientClick} className={classes.link}>
                          {byClientPattern}
                        </span>
                      </>
                    )}
                  </Typography>
                </>
              )}
              {groupUpdatedIndex !== -1 &&
                departmentCreatedIndex === -1 &&
                departmentDeletedIndex === -1 &&
                departmentUpdatedIndex === -1 &&
                groupCreatedIndex === -1 &&
                groupDeletedIndex === -1 && (
                  <>
                    <Typography noWrap style={{ fontSize: isMobile ? '11px' : '14px' }}>
                      <span onClick={handleGroupUpdatedClick} className={classes.link}>
                        {groupName}
                      </span>
                      {' group updated'}
                      {value.includes(' by ') && byClientPattern && (
                        <>
                          {' by '}
                          <span onClick={handleClientClick} className={classes.link}>
                            {byClientPattern}
                          </span>
                        </>
                      )}
                    </Typography>
                  </>
                )}
              {groupDeletedIndex !== -1 &&
                departmentCreatedIndex === -1 &&
                departmentDeletedIndex === -1 &&
                departmentUpdatedIndex === -1 &&
                groupCreatedIndex === -1 &&
                groupUpdatedIndex === -1 && (
                  <>
                    <Typography noWrap style={{ fontSize: isMobile ? '11px' : '14px' }}>
                      <span onClick={handleGroupDeletedClick} className={classes.link}>
                        {groupName}
                      </span>
                      {' group deleted'}
                      {value.includes(' by ') && byClientPattern && (
                        <>
                          {' by '}
                          <span onClick={handleClientClick} className={classes.link}>
                            {byClientPattern}
                          </span>
                        </>
                      )}
                    </Typography>
                  </>
                )}
              {userForIndex !== -1 &&
                value.includes(' by ') &&
                departmentCreatedIndex === -1 &&
                groupCreatedIndex === -1 &&
                departmentDeletedIndex === -1 &&
                groupDeletedIndex === -1 &&
                departmentUpdatedIndex === -1 &&
                groupUpdatedIndex === -1 && (
                  <>
                    <Typography noWrap style={{ fontSize: isMobile ? '11px' : '14px' }}>
                      {value.substring(0, userForIndex + 5)}
                      <span onClick={handleUserForClick} className={classes.link}>
                        {userForPattern}
                      </span>
                      {' by '}
                      <span onClick={handleClientClick} className={classes.link}>
                        {byClientPattern}
                      </span>
                    </Typography>
                  </>
                )}
              {testClientIndex !== -1 &&
                userForIndex === -1 &&
                departmentCreatedIndex === -1 &&
                groupCreatedIndex === -1 &&
                departmentDeletedIndex === -1 &&
                groupDeletedIndex === -1 &&
                departmentUpdatedIndex === -1 &&
                groupUpdatedIndex === -1 && (
                  <>
                    <Typography noWrap style={{ fontSize: isMobile ? '11px' : '14px' }}>
                      {value.substring(0, userIdPatternIndex !== -1 ? userIdPatternIndex : testClientIndex)}
                      {userIdPatternIndex !== -1 && userIdPatternIndex < testClientIndex && (
                        <span onClick={handleUserId} className={classes.link}>
                          (ID: {value.match(/\(ID:\s*([^)]+)\)/)?.[1]})
                        </span>
                      )}
                      {userIdPatternIndex !== -1 &&
                        userIdPatternIndex < testClientIndex &&
                        value.substring(value.indexOf(')') + 1, testClientIndex)}
                      <span onClick={handleClientClick} className={classes.link}>
                        {byClientPattern || 'Test clientdddddd'}
                      </span>
                      {value.substring(testClientIndex + 'Test clientdddddd'.length)}
                    </Typography>
                  </>
                )}
              {/* Handle any 'by' pattern that uses dynamic client names */}
              {testClientIndex === -1 &&
                value.includes(' by ') &&
                byClientPattern &&
                userForIndex === -1 &&
                departmentCreatedIndex === -1 &&
                groupCreatedIndex === -1 &&
                departmentDeletedIndex === -1 &&
                groupDeletedIndex === -1 &&
                departmentUpdatedIndex === -1 &&
                groupUpdatedIndex === -1 &&
                userIdPatternIndex === -1 &&
                emailIndex === -1 &&
                !(parsed.groupName || parsed.deptName || parsed.endUserEmail || parsed.isAttributeMapping) && (
                  <>
                    <Typography noWrap style={{ fontSize: isMobile ? '11px' : '14px' }}>
                      {userIdPatternIndex !== -1 && (
                        <>
                          {value.substring(0, userIdPatternIndex)}
                          <span onClick={handleUserId} className={classes.link}>
                            (ID: {value.match(/\(ID:\s*([^)]+)\)/)?.[1]})
                          </span>
                          {value.substring(value.indexOf(')') + 1).split(' by ')[0]} by
                        </>
                      )}
                      {userIdPatternIndex === -1 && <>{value.split(' by ')[0]} by</>}
                      <span onClick={handleClientClick} className={classes.link}>
                        {byClientPattern}
                      </span>
                    </Typography>
                  </>
                )}
              {testClientIndex === -1 &&
                userIdPatternIndex !== -1 &&
                departmentCreatedIndex === -1 &&
                groupCreatedIndex === -1 &&
                departmentDeletedIndex === -1 &&
                groupDeletedIndex === -1 &&
                departmentUpdatedIndex === -1 &&
                groupUpdatedIndex === -1 && (
                  <>
                    <Typography noWrap style={{ fontSize: isMobile ? '11px' : '14px' }}>
                      {value.substring(0, userIdPatternIndex)}
                      <span onClick={handleUserId} className={classes.link}>
                        (ID: {value.match(/\(ID:\s*([^)]+)\)/)?.[1]})
                      </span>
                      {value.substring(value.indexOf(')') + 1)}
                    </Typography>
                  </>
                )}
              {emailIndex !== -1 &&
                testClientIndex === -1 &&
                userIdPatternIndex === -1 &&
                userForIndex === -1 &&
                departmentCreatedIndex === -1 &&
                groupCreatedIndex === -1 &&
                departmentDeletedIndex === -1 &&
                groupDeletedIndex === -1 &&
                departmentUpdatedIndex === -1 &&
                groupUpdatedIndex === -1 && (
                  <>
                    <Typography noWrap style={{ fontSize: isMobile ? '11px' : '14px' }}>
                      {value.substring(0, emailIndex)}
                      <span onClick={handleEmailClick} className={classes.link}>
                        {emailMatch[0]}
                      </span>
                      {value.substring(emailIndex + emailMatch[0].length)}
                    </Typography>
                  </>
                )}
              {/* Handle User synced messages */}
              {value.startsWith('User synced') && (
                <Typography noWrap style={{ fontSize: isMobile ? '11px' : '14px' }}>
                  {truncatedDescriptionInitialize}
                </Typography>
              )}
              {/* Handle end-user self-referential messages (You logged in, Your account was synced, etc.) */}
              {value.startsWith('Your account was synced with') && (
                <Typography noWrap style={{ fontSize: isMobile ? '11px' : '14px' }}>
                  {truncatedDescriptionInitialize}
                </Typography>
              )}
              {/* Add a general 'by' pattern handler for any message with 'by' */}
              {userNameIndex === -1 &&
                userIdIndex === -1 &&
                userGroupIndex === -1 &&
                userProfileIndex === -1 &&
                userUpgradeIndex === -1 &&
                userIndex === -1 &&
                userPassword === -1 &&
                userDepartmentIndex === -1 &&
                userAcceptedIndex === -1 &&
                userlogIndex === -1 &&
                testClientIndex === -1 &&
                userIdPatternIndex === -1 &&
                emailIndex === -1 &&
                userForIndex === -1 &&
                departmentCreatedIndex === -1 &&
                groupCreatedIndex === -1 &&
                departmentDeletedIndex === -1 &&
                groupDeletedIndex === -1 &&
                departmentUpdatedIndex === -1 &&
                groupUpdatedIndex === -1 &&
                !value.includes(' by ') && (
                  <Typography noWrap style={{ fontSize: isMobile ? '11px' : '14px' }}>
                    {truncatedDescription}
                  </Typography>
                )}
            </div>
            {value.length > (isMobile ? 50 : 100) && (
              <Button
                style={{
                  color: 'blue',
                  display: 'flex',
                  alignItems: 'flex-end',
                  justifyContent: 'flex-end',
                  fontSize: isMobile ? '10px' : '12px',
                  minWidth: isMobile ? '60px' : 'auto',
                  padding: isMobile ? '2px 4px' : '6px 8px',
                }}
                onClick={() => {
                  // Check if message has any links
                  const fullParsed = parseLogMessage(value);
                  if (fullParsed.hasClickableElements) {
                    // Create enhanced dialog with links
                    const dialogContent = (
                      <div style={{ fontSize: '14px', lineHeight: '1.5' }}>{renderMessageWithLinks(value)}</div>
                    );
                    setSelectedDescription(dialogContent);
                  } else {
                    // Use plain text for messages without links
                    setSelectedDescription(value);
                  }
                  setOpen(true);
                }}
              >
                {isMobile ? 'More' : 'Read more...'}
              </Button>
            )}
          </div>
        );
      },
    },
    ...(headtitle !== 'cloud'
      ? [
          {
            field: 'ip',
            headerName: 'LOCATION',
            flex: 2,
            renderHeader: () => (
              <Tooltip title='LOCATION' placement='top' enterTouchDelay={0} leaveTouchDelay={1500} arrow>
                <span
                  style={{
                    fontSize: isMobile ? '10px' : isTablet ? '12px' : '14px',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    display: 'block',
                    textAlign: 'center',
                    lineHeight: isMobile ? '1.2' : '1.4',
                  }}
                >
                  LOCATION
                </span>
              </Tooltip>
            ),
            renderCell: (params: GridCellParams) => {
              const ip = params.row.ip || 'N/A';
              const city = params.row.city || '';
              const country = params.row.country || '';
              const postal = params.row.zip_code || '';
              const region = params.row.region || '';
              return (
                <Tooltip
                  title={
                    <div>
                      <span>{ip}</span>
                      <br />
                      <span>{city}</span>
                      <br />
                      <span>{country}</span>
                      <br />
                      <span>{postal}</span>
                      <br />
                      <span>{region}</span>
                    </div>
                  }
                  placement='top'
                  enterTouchDelay={0}
                  leaveTouchDelay={1500}
                  arrow
                >
                  <div
                    style={{
                      display: 'flex',
                      gap: isMobile ? '4px' : '10px',
                      alignItems: 'center',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      maxWidth: '100%',
                    }}
                  >
                    <img
                      src={IPIcon}
                      alt=''
                      style={{ width: isMobile ? '14px' : '16px', height: isMobile ? '14px' : '16px' }}
                    />
                    <span style={{ fontSize: isMobile ? '11px' : '13px' }}>
                      {ip}
                      {city ? `,${city}` : ''}
                      {country ? `, ${country}` : ''}
                      {region ? `, ${region} ` : ''}
                    </span>
                  </div>
                </Tooltip>
              );
            },
          },
        ]
      : []),
  ];
  return (
    <>
      {headtitle === 'enduser' && user?.permission === 'EndUser' && riskData && (
        <EndUserSecurityInsights risk={riskData} />
      )}
      <Grid container justify='space-between' alignItems='center' className={classes.box}>
        <div className={classes.flex}>
          <DateRangePicker
            initialRange={dateRangeFilter}
            customRanges={[
              { label: 'Show All', startDate: showAllDateRange.startDate, endDate: showAllDateRange.endDate },
            ]}
            onChange={setDateRangeFilter}
          />
          <Select
            fullWidth={isMobile}
            className={classes.select}
            MenuProps={{
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
              },
              transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
              },
              getContentAnchorEl: null,
            }}
            multiple
            value={groupFilter}
            onChange={setGroupFilter}
            displayEmpty
            renderValue={groupFilter.length !== 0 ? getRenderValueForGroupSelect : () => <div>Select</div>}
            input={<BootstrapInput />}
          >
            {filterGroupsList.map((group) => (
              <MenuItem key={group} value={group}>
                <Checkbox checked={groupFilter.includes(group)} className={classes.checkbox} />
                <ListItemText primary={`${capitalizeFirstLetter(group)}s`} />
              </MenuItem>
            ))}
          </Select>
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: isMobile ? 'column' : 'row',
            gap: isMobile ? '12px' : '8px',
            width: isMobile ? '100%' : 'auto',
            justifyContent: isMobile ? 'stretch' : 'flex-end',
          }}
        >
          <div
            style={{
              width: isMobile ? '100%' : isTablet ? '250px' : '300px',
              minWidth: isMobile ? 'auto' : '200px',
            }}
          >
            <Search
              handelSearch={(filter: string) => {
                setSearchTerm(filter);
                setPage(0); // Reset to first page when searching
              }}
            />
          </div>
          <div style={{ width: isMobile ? '100%' : 'auto' }}>
            <Button
              onClick={handleClick}
              style={{
                color: '#4682B4',
                fontSize: isMobile ? '12px' : isTablet ? '13px' : '14px',
                padding: isMobile ? '8px 16px' : '8px 16px',
                width: isMobile ? '100%' : 'auto',
                justifyContent: isMobile ? 'center' : 'flex-start',
              }}
            >
              <DownloadIcon
                style={{
                  color: '#4682B4',
                  fontSize: isMobile ? '18px' : '20px',
                  marginRight: '4px',
                }}
              />
              {isMobile ? 'Export' : 'Exports'}
            </Button>
            <Menu
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleClose}
              style={{ top: '45px' }}
            >
              <MenuItem
                onClick={() => {
                  handleExportCSV();
                  handleClose();
                }}
              >
                Download as CSV
              </MenuItem>
              <MenuItem
                onClick={() => {
                  handleExportXLS();
                  handleClose();
                }}
              >
                Download as Excel
              </MenuItem>
              <MenuItem
                onClick={() => {
                  handleExportPDF();
                  handleClose();
                }}
              >
                Download as PDF
              </MenuItem>
            </Menu>
          </div>
        </div>
      </Grid>
      <Paper className={classes.dataGrid} elevation={0}>
        <div
          style={{
            minWidth: isMobile ? 900 : '100%',
            overflowX: 'auto',
          }}
        >
          <DataGrid
            key={totalRows}
            className={classes.noBorder}
            disableSelectionOnClick
            getRowClassName={(params: GridRowParams) => `row-background-${params.row.type || 'default'}`}
            sortingOrder={['desc', 'asc']}
            sortModel={[
              {
                field: 'id',
                sort: 'desc' as GridSortDirection,
              },
            ]}
            autoHeight
            rows={rows}
            columns={columns}
            pageSize={pageSize}
            rowsPerPageOptions={[10, 25, 50, 100]}
            pagination
            paginationMode='server'
            rowCount={totalRows}
            page={page}
            onPageChange={(params) => {
              setPage(params.page);
            }}
            onPageSizeChange={(params) => {
              setPageSize(params.pageSize);
              setPage(0);
            }}
            onCellClick={(event: GridCellParams) => setClickedId(+event.id)}
            density={isMobile ? 'compact' : 'standard'}
            disableColumnSelector={isMobile}
            disableColumnMenu={isMobile}
          />
        </div>
      </Paper>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogContent dividers>{selectedDescription}</DialogContent>
      </Dialog>
      {clickedId && !getLogsInfoReq.isLoading ? (
        <AdditionalDataPopUp open={openAdditionalDataPopUp} handleClose={handleCloseAdditionalDataPopUp} />
      ) : (
        ''
      )}{' '}
    </>
  );
});
